import cookies from 'js-cookie'
import { getDataType } from '@/utils/common'

const storageTitle = 'aiciting-web-'

const storage = {
  setItem: (key, value, type = 'cookie', option = {}) => {
    value = value === undefined ? '' : value

    if (value) {
      if (getDataType(value) === 'number') {
        value = value.toString()
      } else if (getDataType(value) === 'object') {
        value = JSON.stringify(value)
      }

      if (type === 'cookie') {
        cookies.set(storageTitle + key, value, option)
      } else {
        localStorage.setItem(storageTitle + key, value)
      }
    }
  },

  getItem: (key, type = 'cookie') => {
    let value = ''
    if (type === 'cookie') {
      value = cookies.get(storageTitle + key)
    } else {
      value = localStorage.getItem(storageTitle + key)
    }
    return value
  },

  removeItem: (key, type = 'cookie') => {
    if (type === 'cookie') {
      cookies.remove(storageTitle + key)
    } else {
      localStorage.removeItem(storageTitle + key)
    }
  },

  clear: (type = 'cookie') => {
    if (type === 'cookie') {
      const cookieList = cookies.get()
      for (const item in cookieList) {
        cookies.remove(item)
      }
    } else {
      localStorage.clear()
    }
  }
}

export default storage
